import validator from "@/libs/rules/validator";
/**登录 */
const login_rules = {
  username: [validator.required("请输入账号")],
  password: [
    validator.required("请输入密码"),
    {
      min: 6,
      max: 16,
      message: "密码格式不正确，请输入6-16位",
      trigger: "blur"
    }
  ],
  verifyCode: [
    validator.required("请输入验证码"),
    {
      min: 4,
      max: 4,
      message: "验证码格式不正确",
      trigger: "blur"
    }
  ]
};
/**修改密码 */
const passwordUpdate_rules = {
  oldPassword: [
    validator.required("请输入原密码"),
    {
      min: 6,
      max: 16,
      message: "密码格式不正确，请输入6-16位",
      trigger: "blur"
    }
  ],
  password: [
    validator.required("请输入密码"),
    {
      validator: validator.checkPwd,
      trigger: "blur"
    }
  ],
  rePassword: [
    validator.required("请输入确认密码"),
    {
      validator: validator.checkPwd,
      trigger: "blur"
    }
  ]
};
/**重置密码 */
const resetPassword_rules = {
  password: [
    validator.required("请输入密码"),
    {
      validator: validator.checkPwd,
      trigger: "blur"
    }
  ]
};
/**修改默认密码 */
const defaultPasswordUpdate_rules = {
  password: [
    validator.required("请输入新密码"),
    {
      validator: validator.checkPwd,
      trigger: "blur"
    }
  ],
  rePassword: [
    validator.required("请输入确认密码"),
    {
      validator: validator.checkPwd,
      trigger: "blur"
    }
  ]
};
/**基本新增 - 赛事、培训班等基本信息 */
const basePlan_rules = {
  orgId: [validator.required("请选择所属单位"), "change"],
  name: [validator.required("请输入单位名称")],
  otherPlanDictItem1Id: [validator.required("请选择类型"), "change"],
  otherPlanDictItem2Id: [validator.required("请选择获得名次"), "change"],
  beginDateTime: [validator.required("请选择开始时间"), "change"],
  endDateTime: [validator.required("请选择结束时间"), "change"],
  province: [validator.required("请选择省份"), "change"],
  city: [validator.required("请选择城市"), "change"],
  address: [validator.required("请输入详细地址")],
  contactPerson: [validator.required("请输入联系人")],
  contactPhone: [
    validator.required("请输入手机号码"),
    {
      validator: validator.checkPhone,
      trigger: "blur"
    }
  ],
  mail: [
    validator.required("请输入邮箱"),
    {
      validator: validator.checkMail,
      trigger: "blur"
    }
  ],
  personNum: [validator.required("请输入人员数量")],
  funds: [
    validator.required("请输入经费"),
    {
      validator: validator.checkFuns,
      trigger: ["change", "blur"]
    }
  ],
  countryFunds: [
    validator.required("请输入总局拨付经费"),
    {
      validator: validator.checkFuns,
      trigger: ["change", "blur"]
    }
  ],
  provinceFunds: [
    validator.required("请输入省市配套经费"),
    {
      validator: validator.checkFuns,
      trigger: ["change", "blur"]
    }
  ]
};
const planGamesRules = {
  orgId: [validator.required("请选择所属单位"), "change"],
  name: [validator.required("请输入单位名称")],
  otherPlanDictItem1Id: [validator.required("请选择类型"), "change"],
  otherPlanDictItem2Id: [validator.required("请选择获得名次"), "change"],
  province: [validator.required("请选择省份"), "change"],
  city: [validator.required("请选择城市"), "change"],
  address: [validator.required("请输入详细地址")],
  contactPerson: [validator.required("请输入联系人")],
  contactPhone: [
    validator.required("请输入手机号码"),
    {
      validator: validator.checkPhone,
      trigger: "blur"
    }
  ],
  mail: [
    validator.required("请输入邮箱"),
    {
      validator: validator.checkMail,
      trigger: "blur"
    }
  ],
  countryFunds: [
    validator.required("请输入总局拨付经费"),
    {
      validator: validator.checkFuns,
      trigger: ["change", "blur"]
    }
  ],
  provinceFunds: [
    validator.required("请输入省市配套经费"),
    {
      validator: validator.checkFuns,
      trigger: ["change", "blur"]
    }
  ]
};
// 新增体育赛事备案
const gameFilingRules = {
  orgId: [validator.required("请选择所属单位"), "change"],
  viewerCount: [validator.required("请输入开放人数")],
  athleteCount: [validator.required("请输入参赛运动员人数")],
  tvRelayName: [validator.required("请输入电视转播渠道名称")],
  networkRelayName: [validator.required("请输入网络转播渠道名称")],
  year: [validator.required("请选择年度")],
  placeType: [validator.required("请选择比赛地点类型")],
  name: [validator.required("请输入赛事名称"), "blur"],
  province: [validator.required("请选择省份"), "change"],
  beginDateTime: [validator.required("请选择举办日期"), "change"],
  // endDateTime: [validator.required("请选择结束时间"), "change"],
  city: [validator.required("请选择城市"), "change"],
  address: [validator.required("请输入详细地址")],
  hostUnit: [validator.required("请输入主办单位"), "blur"],
  underTakeUnit: [validator.required("请输入承办单位"), "blur"],
  fundResources: ["blur"],
  contactPerson: [validator.required("请输入联系人")],
  contactPhone: [
    validator.required("请输入手机号码"),
    {
      validator: validator.checkPhone,
      trigger: "blur"
    }
  ],
  useFundAmount: [
    validator.required("请输入使用金额"),
    {
      validator: validator.nums,
      trigger: "blur"
    }
  ]
};
const basePlan_new_rules = {
  orgId: [validator.required("请选择所属单位"), "change"],
  name: [validator.required("请输入体校名称")],
  otherPlanDictItem1Id: [validator.required("请选择项目"), "change"],
  otherPlanDictItem2Id: [validator.required("请选择省份"), "change"],
  address: [validator.required("请输入详细地址")],
  contactPerson: [validator.required("请输入联系人")],
  contactPhone: [
    validator.required("请输入手机号码"),
    {
      validator: validator.checkPhone,
      trigger: "blur"
    }
  ],
  mail: [
    validator.required("请输入邮箱"),
    {
      validator: validator.checkMail,
      trigger: "blur"
    }
  ],
  funds: [
    validator.required("请输入经费"),
    {
      validator: validator.checkFuns,
      trigger: ["change", "blur"]
    }
  ],
  countryFunds: [
    validator.required("请输入总局拨付经费"),
    {
      validator: validator.checkFuns,
      trigger: ["change", "blur"]
    }
  ],
  provinceFunds: [
    validator.required("请输入省市配套经费"),
    {
      validator: validator.checkFuns,
      trigger: ["change", "blur"]
    }
  ]
};
/**新增赛事 */
const game_rules = {
  ...basePlan_rules,
  tag: [validator.required("请选择赛事类型"), "change"],
  scope: [validator.required("请选择赛事级别"), "change"],
  disciplineList: [
    { required: true, message: "大项不能为空" },
    {
      validator: validator.checkDisciplineList,
      trigger: ["change", "blur"]
    }
  ],
  generation: [validator.required("请输入年龄段")]
};
/**新增传统校 */
const traditionalSchool_rules = {
  ...basePlan_rules,
  disciplineList: [
    { required: true, message: "大项不能为空" },
    {
      validator: validator.checkDisciplineList,
      trigger: ["change", "blur"]
    }
  ]
};
/**新增俱乐部比赛 */
const club_rules = {
  ...basePlan_rules,
  disciplineList: [
    { required: true, message: "大项不能为空" },
    {
      validator: validator.checkDisciplineList,
      trigger: ["change", "blur"]
    }
  ]
};
/**新增赛事活动 */
const activities_rules = {
  ...basePlan_rules,
  type: [validator.required("请选择赛事分类"), "change"],
  tag: [validator.required("请选择赛事类型"), "change"],
  scope: [validator.required("请选择赛事级别"), "change"],
  disciplineList: [
    { required: true, message: "大项不能为空" },
    {
      validator: validator.checkDisciplineList,
      trigger: ["change", "blur"]
    }
  ],
  generation: [validator.required("请输入年龄段")]
};
/**新建 - 系统管理员、项目中心、省、操作员 */
const planOther_rules = {
  orgId: [validator.required("请选择所属单位"), "change"],
  name: [validator.required("请输入单位名称")]
};

/**新增培训班 */
const class_rules = {
  ...basePlan_rules,
  trainingClassType: [validator.required("请选择培训类型"), "change"],
  disciplineList: [
    { required: true, message: "大项不能为空" },
    {
      validator: validator.checkDisciplineList,
      trigger: ["change", "blur"]
    }
  ],
  times: [
    validator.required("请输入期次"),
    {
      validator: validator.times,
      trigger: ["change", "blur"]
    }
  ]
};
/**新增足球*/
const football_rules = {
  ...basePlan_rules,
  type: [
    validator.required("请选择足球类型", "change"),
    {
      validator: validator.footballType,
      trigger: ["change"]
    }
  ]
};
/**培训班基本信息 */
const base_rules = {
  ...basePlan_rules
};

// 青少年足球
const planOtherItem_rules = {
  orgId: [validator.required("请选择所属单位"), "change"],
  name: [validator.required("请输入名称")],
  province: [validator.required("请选择省份"), "change"],
  city: [validator.required("请选择城市"), "change"],
  address: [validator.required("请输入详细地址")],
  contactPerson: [validator.required("请输入联系人")],
  contactPhone: [
    validator.required("请输入手机号码"),
    {
      validator: validator.checkPhone,
      trigger: "blur"
    }
  ],
  mail: [
    validator.required("请输入邮箱"),
    {
      validator: validator.checkMail,
      trigger: "blur"
    }
  ],
  countryFunds: [
    validator.required("请输入总局拨付经费"),
    {
      validator: validator.checkFuns,
      trigger: ["change", "blur"]
    }
  ],
  provinceFunds: [
    validator.required("请输入省市配套经费"),
    {
      validator: validator.checkFuns,
      trigger: ["change", "blur"]
    }
  ],
  otherPlanDictItem1Id: [validator.required("请选择项目"), "change"],
  otherPlanDictItem2Id: [validator.required("请选择项目内容"), "change"]
};

export default {
  login_rules,
  passwordUpdate_rules,
  resetPassword_rules,
  defaultPasswordUpdate_rules,
  basePlan_rules,
  basePlan_new_rules,
  game_rules,
  traditionalSchool_rules,
  club_rules,
  activities_rules,
  class_rules,
  base_rules,
  football_rules,
  planOther_rules,
  planOtherItem_rules,
  planGamesRules,
  gameFilingRules
};
